<template>
  <v-card max-width="600">
    <v-toolbar class="ou-toolbar">
      <v-toolbar-title class="ou-toolbar-text">
        {{ title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-radio-group v-model="path">
        <v-radio
          label="Create a new political campaign account on Outfox AI"
          :value="true"
        ></v-radio>
        <v-radio
          v-if="!agency"
          label="Join an existing political campaign account on Outfox AI"
          :value="false"
        ></v-radio>
      </v-radio-group>
      <v-container
        fluid
        grid-list-md
        v-if="!path"
        >
        <v-layout
          row
          wrap
          v-if="existingPages.length"
        >
          <v-flex
            d-flex
            xs12
            sm6
            v-for="page in existingPages"
            :key="page.id"
          >
            <v-card
              :color="getColor(page.id)"
              @click="selectPage(page)"
            >
              <div class="caption pa-1">{{ page.category }}</div>
              <v-card-text @click="selectPage(page)" style="cursor: pointer">
                <div class="body-2 text-xs-center">{{ page.name }}</div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else>
          <v-card>
            <v-card-text>We could not find existing political campaigns matched with your account</v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="primary" :disabled="!valid" @click="next">Next</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import firebase from '../../firebase/main'
export default {
  name: 'TheWelcomeThirdPage',
  data () {
    return {
      path: true,
      valid: true,
      selectedPage: null
    }
  },
  props: {
    agency: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'Welcome to Outfox AI'
    }
  },
  computed: {
    pages () {
      const user = this.$store.getters.getCurrentUser
      if (!user) return []
      return user.accounts
    },
    advertisers () {
      return this.$store.getters.getAdvertisers
    },
    existingPages () {
      return this.pages.filter(page => this.advertisers.find(a => a.data.fb_page_id === page.id))
    }
  },
  methods: {
    getColor (id) {
      return (this.selectedPage && this.selectedPage.id === id) ? 'green lighten-3' : ''
    },
    isAdvertiserExist () {
      const user = this.$store.getters.getCurrentUser
      if (!user.firebaseAccount.advertisers) return false
      const advertiser = this.advertisers.find(a => a.data.fb_page_id === this.selectedPage.id)
      return !!user.firebaseAccount.advertisers.find(a => a.id === advertiser.id)
    },
    next () {
      if (this.path) {
        this.$emit('setCampaign', null)
      } else {
        if (this.selectedPage) {
          if (this.isAdvertiserExist()) {
            this.$store.dispatch('showNotification', {
              type: 'warning',
              message: ['You already joined to this account.']
            })
            return false
          }
          new Promise(resolve => {
            const id = this.advertisers.find(a => a.data.fb_page_id === this.selectedPage.id).id
            resolve(firebase.Advertisers.getAdvertiserById(id))
          })
            .then(res => {
              this.$emit('setCampaign', res)
            })
        } else {
          this.valid = false
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: ['Select an existing campaign']
          })
        }
      }
    },
    selectPage (page) {
      this.valid = true
      this.selectedPage = page
    }
  },
  watch: {
    path (val) {
      if (val) this.selectedPage = null
      this.valid = true
    }
  }
}
</script>

<style scoped>

</style>
